var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('Chip',_vm._b({},'Chip',{ text: _vm.text, type: _vm.type, icon: _vm.icon},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }